import angular from 'angular';
import moment from 'moment';
import { generateExample } from '../../common/directives/numberFormatDrv';

angular.module('cxSettings').directive('cxBookyearSettings', [
  'flySvc',
  '$q',
  function(flySvc, $q) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        data: '=',
        label: '@',
        save: '&',
        type: '@',
        disabled: '=?',
        yearFormat: '=?',
      },
      template: require('./bookyearSettings.html'),
      link: function(scope) {
        scope.collapsed = false;
        scope.toggleOpen = function() {
          scope.collapsed = !scope.collapsed;
        };
        scope.dateOptions = {
          maxMode: 'month',
          startingDay: 1,
        };
        scope.submit = function(value, field) {
          if (field === 'startDate') {
            if (!value) return false;
            var cleanValue = moment(value)
              .clone()
              .startOf('day')
              .toDate();
            var lowerBound =
              scope.type === 'CURRENT'
                ? moment
                    .utc()
                    .add(-1, 'years')
                    .startOf('day')
                    .toDate()
                : moment
                    .utc()
                    .startOf('day')
                    .toDate();
            if (cleanValue <= lowerBound) {
              flySvc.message('msgDateCannotBeSetBefore', {
                date: lowerBound.ISO(),
              });
              return false;
            }
          }
          if (field === 'invoiceNumberStartValue' || field === 'creditNoteNumberStartValue') {
            if (!value || parseInt(value) <= 0) value = 1;
          }
          if (value === scope.data[field]) return false;
          var model = angular.copy(scope.data);
          model[field] = value;
          return $q.when(
            scope.save({
              newValue: model,
            }),
          );
        };
        scope.generateExample = generateExample;
      },
    };
  },
]);
